import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import React from 'react';
const buttonVariants = cva('inline-flex items-center justify-center gap-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring font-medium leading-[1]', {
  variants: {
    variant: {
      default: 'bg-[--primary] text-white hover:bg-[#2b3482] px-2 py-[6px] text-xs border-[--primary] rounded-[4px] border disabled:pointer-events-none disabled:bg-[#BDBDBD] disabled:border-[#ECECEC] disabled:text-white',
      login: 'bg-[--primary] text-white hover:bg-[#2b3482] px-8 py-3 text-sm 2xl:text-base 2xl:py-4 2xl:px-12 rounded-[10px] border',
      outline: 'bg-[--outlinebtnbg] text-[--primary] hover:bg-[--outlinebtnbghover] hover:text-[--primary] px-1 py-[6px] text-xs border-[--outlinecolor] rounded-[4px] border disabled:pointer-events-none disabled:bg-[#D2D2D233] disabled:border-[#ECECEC] disabled:text-[--lablecolor]',
      destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
      secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
      ghost: 'hover:bg-accent hover:text-accent-foreground',
      bottomnav: 'hover:bg-[#E3E3E35E]',
      active: 'bg-[#E3E3E35E]',
      link: 'text-primary underline-offset-4 hover:underline'
    },
    size: {
      default: '',
      login: '',
      sm: '',
      lg: '',
      icon: 'h-9 w-9 '
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant,
  size,
  asChild = false,
  type = 'button',
  ...props
}, ref) => {
  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(buttonVariants({
    variant,
    size,
    className
  }))} ref={ref} {...Comp === 'button' ? {
    type
  } : {}} {...props} />;
});
Button.displayName = 'Button';
export { Button, buttonVariants };